"use client";
import { useEffect } from "react";
import { PageAnalyticsDetails, sendPageAnalytics } from "./page-tracking";
import { useGeolocation } from "../Geolocation";
import { isTrackingEnabled } from "./gtm-init";

type Props = Omit<PageAnalyticsDetails, "language" | "countryCode">;

const SendPageTracking: React.FC<Props> = (props) => {
  const geolocation = useGeolocation();

  useEffect(() => {
    if (!isTrackingEnabled) return;

    sendPageAnalytics({
      language: "en",
      countryCode: geolocation.countryCode,
      market: geolocation.market,
      ...props
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default SendPageTracking;
